import { ApiService, type ApiRequestConfig } from "./api.service";
import type { TWorkspacePasswordPolicy, TWorkspacePasswordPolicyUpdate } from "@/types/workspace";

export class WorkspacePasswordPolicyService extends ApiService {
  async getPasswordPolicy(
    slug: string,
    config?: ApiRequestConfig,
  ): Promise<TWorkspacePasswordPolicy> {
    return this.get(`/api/workspaces/${slug}/password-policy/`, config);
  }

  async updatePasswordPolicy(
    slug: string,
    data: TWorkspacePasswordPolicyUpdate,
  ): Promise<TWorkspacePasswordPolicy> {
    return this.patch(`/api/workspaces/${slug}/password-policy/`, data);
  }
}
